import { Action } from '@ngrx/store';
import { SarState } from '@app/models';

export enum SarActionTypes {
  Load = '[API] Load sar states',
  LoadSuccess = '[API] Load sar states success',
  LoadFail = '[API] Load sar states fail',
  AddAll = '[SarState] Add all',
  Create = '[API] Create sar state ',
  CreateSuccess = '[API] Create sar state success',
  CreateFail = '[API] Create sar state fail',
  AddOne = '[SarState] Add one',
  Update = '[API] Update sar state ',
  UpdateSuccess = '[SarState] Update sar state success',
  UpdateFail = '[SarState] Update sar state fail',
  UpdateOne = '[SarState] Update one',
  //   Delete = '[API] Delete port ',
  //   DeleteSuccess = '[Port]  Delete port success',
  //   DeleteFail = '[Port]  Delete port fail'
}

export class Load implements Action {
  readonly type = SarActionTypes.Load;
  constructor(public options?: any) { }
}

export class LoadSuccess implements Action {
  readonly type = SarActionTypes.LoadSuccess;
  constructor(public sarStates: SarState[]) { }
}

export class LoadFail implements Action {
  readonly type = SarActionTypes.LoadFail;
  constructor(public error: any) { }
}

export class Create implements Action {
  readonly type = SarActionTypes.Create;
  constructor(public sarState: any) { }
}

export class CreateSuccess implements Action {
  readonly type = SarActionTypes.CreateSuccess;
  constructor(public sarState: any) { }
}

export class CreateFail implements Action {
  readonly type = SarActionTypes.CreateFail;
  constructor(public error: any) { }
}

export class Update implements Action {
  readonly type = SarActionTypes.Update;
  constructor(public id: number, public sarState: any) { }
}
export class UpdateFail implements Action {
  readonly type = SarActionTypes.UpdateFail;
  constructor(public error: any) { }
}

export class UpdateSuccess implements Action {
  readonly type = SarActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) { }
}

export class UpdateOne implements Action {
  readonly type = SarActionTypes.UpdateOne;
  constructor(public sarState: any) { }
}

export class AddAll implements Action {
  readonly type = SarActionTypes.AddAll;
  constructor(public sarStates: SarState[]) { }
}

export class AddOne implements Action {
  readonly type = SarActionTypes.AddOne;
  constructor(public sarState: SarState) { }
}

export type SarStateActionsUnion =
  | Load
  | LoadFail
  | LoadSuccess
  | Create
  | CreateSuccess
  | CreateFail
  | Update
  | UpdateFail
  | UpdateSuccess
  | UpdateOne
  | AddAll
  | AddOne;